import { createElement } from "@wordpress/element";
export default function Spinner() {
  return createElement("span", {
    className: "components-spinner"
  });
}
//# sourceMappingURL=index.js.map